import '~/scenes/registration/shared/methods/styles.scss'

import React from 'react'
import { useValues } from 'kea'
import ReactHtmlParser from 'react-html-parser'

import I18n from 'lib/i18n'

import logic from '../logic'

const Methods = () => {
  const { urls } = useValues(logic)

  const { google, facebook } = urls

  return (
    <div className='signup-methods'>
      <div className='method-button'>
        <a className='facebook-login' href={facebook} target='_top' data-method='post'>
          {ReactHtmlParser(I18n.t('devise.sessions.new.login_facebook'))}
        </a>
      </div>
      <div className='method-button'>
        <a className='google-login' href={google} target='_top' data-method='post'>
          {ReactHtmlParser(I18n.t('devise.sessions.new.login_google'))}
        </a>
      </div>
    </div>
  )
}

export default Methods
